import { Button, Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle, Label, Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@1trading/react';
import { useState } from 'react';

interface NominateApproverDialogProps {
  approvers: string[];
  onClose: () => void;
  onNominate: (approverEmail: string) => Promise<void>;
}

// There is deliberately no default approver - nominating one is an explicit choice
export const NominateApproverDialog = ({ approvers, onClose, onNominate }: NominateApproverDialogProps) => {
  const [approver, setApprover] = useState('');
  const [isSubmitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!approver) return;
    setSubmitting(true);
    try {
      await onNominate(approver);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog onOpenChange={(open) => (open ? undefined : onClose())} open>
      <DialogContent className="sm:max-w-[420px]">
        <DialogHeader>
          <DialogTitle>Send for approval</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col gap-1.5">
          <Label htmlFor="notification-approver">Approver</Label>
          <Select onValueChange={setApprover} value={approver}>
            <SelectTrigger id="notification-approver">
              <SelectValue placeholder="Select an approver" />
            </SelectTrigger>
            <SelectContent>
              {approvers.map((email) => (
                <SelectItem key={email} value={email}>
                  {email}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <p className="text-xs text-muted-foreground">Legal review and the nominated approver's sign-off happen from this list.</p>
        </div>
        <DialogFooter>
          <Button onClick={onClose} type="button" variant="outline">
            Cancel
          </Button>
          <Button disabled={approver === '' || isSubmitting} onClick={handleSubmit} type="button" variant="primary">
            Send for approval
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
NominateApproverDialog.displayName = 'NominateApproverDialog';
